import { useQuery } from "@tanstack/react-query";
import { getAuthValue } from "../../authModule/hooks/useAuthValue";
import { GET_TENANTS_LOGO_QUERY_KEY } from "../types/CommonTypes";
import { enableApiHeaders, fetcher } from "../../../utils/Axios";

async function getTenantLogo(providedTenantId?: string): Promise<any> {
  const { tenantId: authTenantId } = getAuthValue();
  const tenantId = providedTenantId ?? authTenantId;

  enableApiHeaders(
    {
      "x-tenant-id": tenantId,
      entityType: "tenant",
    },
    {
      includeHospitalId: false,
    }
  );
  const { data } = await fetcher({
    url: "admin/file",
  });
  return data;
}

function useGetTenantLogoQuery(tenantId?: string, enabled: boolean = true) {
  return useQuery({
    queryKey: [GET_TENANTS_LOGO_QUERY_KEY, tenantId],
    queryFn: () => getTenantLogo(tenantId),
    enabled: !!tenantId && enabled,
  });
}

export default useGetTenantLogoQuery;
